import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function SectionNav({ tabs }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="border-b border-border -mx-4 md:-mx-6 -mt-4 md:-mt-6 px-4 md:px-6 bg-background sticky top-0 z-10 overflow-x-auto scrollbar-hide">
      <div className="flex gap-0 min-w-max">
        {tabs.map((tab) => {
          const active = location.pathname === tab.path;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={`px-3.5 py-2.5 text-xs font-medium border-b-2 transition-colors whitespace-nowrap ${
                active
                  ? 'border-emerald-500 text-emerald-600 dark:text-emerald-400'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
